<script>
import { options as loadAreaOptions } from '@/api/bdPortArea'
import { page as loadMainPortPage } from '@/api/bdMainPort'

export default {
  name: 'MainPortCascader',
  props: {
    value: {
      type: [Number, String]
    },
    mainPortName: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: true
    },
    filterable: {
      type: Boolean,
      default: true
    },
    placeholder: {
      type: String,
      default: '请选择主港口'
    },
    size: {
      type: String
    },
    showAllLevels: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      options: [],
      innerValue: [],
      allLoaded: false,
      allLoading: false,
      mainPortIdPathMap: {},
      mainPortIdNameMap: {},
      suppressEmit: false,
      syncing: false
    }
  },
  computed: {
    cascaderProps() {
      return {
        expandTrigger: 'hover',
        emitPath: true,
        checkStrictly: false,
        value: 'value',
        label: 'label',
        children: 'children'
      }
    }
  },
  mounted() {
    this.loadAllOptions()
  },
  watch: {
    value: {
      immediate: true,
      handler(newValue) {
        this.syncFromValue(newValue)
      }
    }
  },
  methods: {
    async loadAllOptions() {
      if (this.allLoaded || this.allLoading) {
        return
      }
      this.allLoading = true
      try {
        const areaRes = await loadAreaOptions()
        const areas = Array.isArray(areaRes.data) ? areaRes.data : []
        const areaNodes = areas.map(item => ({
          value: item.value,
          label: item.label,
          children: []
        }))

        const mainPortRes = await loadMainPortPage({
          page: 1,
          size: 9999,
          sort: []
        })
        const mainPorts = mainPortRes.data && Array.isArray(mainPortRes.data.records) ? mainPortRes.data.records : []
        const areaIdToMainPorts = mainPorts.reduce((acc, item) => {
          const areaId = item && item.areaId
          if (!areaId) {return acc}
          if (!acc[areaId]) {acc[areaId] = []}
          acc[areaId].push(item)
          return acc
        }, {})

        areaNodes.forEach(areaNode => {
          const children = areaIdToMainPorts[areaNode.value] || []
          areaNode.children = children.map(mp => {
            this.mainPortIdPathMap[mp.id] = [areaNode.value, mp.id]
            this.mainPortIdNameMap[mp.id] = mp.name
            return {
              value: mp.id,
              label: mp.name
            }
          })
        })

        this.options = areaNodes
        this.allLoaded = true

        if (this.value !== undefined && this.value !== null && this.value !== '') {
          const path = this.mainPortIdPathMap[this.value]
          const name = this.mainPortIdNameMap[this.value] || null
          if (path) {
            this.suppressEmit = true
            this.innerValue = path.slice()
            this.$emit('update:mainPortName', name)
            this.$nextTick(() => {
              this.suppressEmit = false
            })
          }
        }
      } finally {
        this.allLoading = false
      }
    },
    async syncFromValue(mainPortId) {
      if (this.syncing) {return}
      this.syncing = true
      try {
        if (mainPortId === undefined || mainPortId === null || mainPortId === '') {
          this.suppressEmit = true
          this.innerValue = []
          this.$emit('update:mainPortName', null)
          this.$nextTick(() => {
            this.suppressEmit = false
          })
          return
        }

        await this.loadAllOptions()
        const path = this.mainPortIdPathMap[mainPortId]
        const name = this.mainPortIdNameMap[mainPortId] || null
        if (!path) {
          return
        }
        this.suppressEmit = true
        this.innerValue = path.slice()
        this.$emit('update:mainPortName', name)
        this.$nextTick(() => {
          this.suppressEmit = false
        })
      } finally {
        this.syncing = false
      }
    },
    async onVisibleChange(visible) {
      if (!visible) {return}
      await this.loadAllOptions()
      this.$nextTick(() => {
        const panel = this.$refs.cascader && this.$refs.cascader.$refs && this.$refs.cascader.$refs.panel
        if (panel && panel.syncActivePath) {
          panel.syncActivePath()
        }
      })
    },
    onClear() {
      if (this.suppressEmit) {return}
      this.$emit('input', null)
      this.$emit('update:mainPortName', null)
    },
    onChange(val) {
      if (this.suppressEmit) {return}
      if (!Array.isArray(val) || !val.length) {
        this.$emit('input', null)
        this.$emit('update:mainPortName', null)
        return
      }
      const mainPortId = val[val.length - 1]
      this.$emit('input', mainPortId)
      this.$nextTick(() => {
        const cascader = this.$refs.cascader
        const checkedNodes = cascader && cascader.getCheckedNodes ? cascader.getCheckedNodes(false) : []
        const node = checkedNodes && checkedNodes.length ? checkedNodes[0] : null
        const name = (node && node.label) || null
        this.$emit('update:mainPortName', name)
      })
    }
  }
}
</script>

<template>
  <el-cascader
    ref="cascader"
    v-model="innerValue"
    :options="options"
    :props="cascaderProps"
    :placeholder="placeholder"
    :disabled="disabled"
    :clearable="clearable"
    :filterable="filterable"
    :size="size"
    :show-all-levels="showAllLevels"
    style="width: 100%;"
    @visible-change="onVisibleChange"
    @change="onChange"
    @clear="onClear"
  />
</template>

<style scoped lang="scss">
</style>

